import { defineStore } from "pinia"
import { EAppVersionCheckDecision } from "./model"

function compareVersions(version1: string, version2: string): boolean {
    const parts1 = version1.split(".").map(part => parseInt(part, 10))
    const parts2 = version2.split(".").map(part => parseInt(part, 10))

    // Дополняем более короткую версию нулями
    const len1 = parts1.length
    const len2 = parts2.length
    const maxLen = Math.max(len1, len2)

    for (let i = 0; i < maxLen; i++) {
        const val1 = i < len1 ? parts1[i] : 0
        const val2 = i < len2 ? parts2[i] : 0

        // Сравнение частей версии
        if (val1 > val2) {
            return false // Версия1 больше или равна версии2
        }
        if (val1 < val2) {
            return true // Версия2 больше
        }
    }

    // Если все части равны, версии идентичны
    return false
}

export const useAppVersionStore = defineStore("appversion", {
    state: () => ({
        lastCheckTimestamp: 0,
        lastCheckVersion: "0.0.0",
        checkDecision: 0 as EAppVersionCheckDecision,
        appStoreUrl: ""
    }),
    persist: { key: "PERSIST_STORAGE_appversion" },
    getters: {
        needToCheckAppVersion: (state) => (currentVersion: string): boolean => {
            if (state.lastCheckTimestamp === 0 || state.checkDecision === EAppVersionCheckDecision.NotSupported)
                return true

            if (compareVersions(state.lastCheckVersion, currentVersion))
                return true

            const currentTime = Math.trunc(Date.now() / 1000) // Получаем текущее время в секундах
            const oneDayInSecs = 24 * 60 * 60 // Количество секунд в сутках

            // Проверяем, прошло ли более суток
            const res = currentTime - state.lastCheckTimestamp > oneDayInSecs
            return res
        }
    },
    actions: {
        saveCurrentTimestampAndVersion(currentVersion: string): void {
            this.lastCheckVersion = currentVersion
            this.lastCheckTimestamp = Math.trunc(Date.now() / 1000)
        }
    }
})
